import React from 'react';
import { useEventsSubscriber, EventData } from 'event-bus';
import {
  TASK_COMPLETED,
  TASK_CREATED,
  TASK_DELETED,
  TASK_UNCOMPLETED,
  TASK_UPDATED,
  TaskEvent, useProjectTasksService,
} from 'nekst-api';
import { toastService } from './toastService';
import { TextLink } from "ui-builder";
import { useOpenUpdateFormHelper } from "../../projects/view/tasks/CreateUpdate/OpenUpdateFormField";


function TaskLink(props: {
  id: number,
  name: string
}) {

  const openTaskHelper = useOpenUpdateFormHelper();

  const projectTasksService = useProjectTasksService();

  const onClick = async () => {
    const task = await projectTasksService.getTask(props.id);
    openTaskHelper.openForm(task);
  }

  return (
    <TextLink
      onClick={onClick}
    >
      {props.name}
    </TextLink>
  )
}

/**
 * Project Tasks Events Toast Listener
 * Subscribes to project task events and displays toast notifications
 */
export default function ProjectTasksEventsToasts() {
  useEventsSubscriber(
    'ProjectTasksEventsToasts',
    {
      [TASK_CREATED]: (eventData: EventData) => {
        const event = eventData as TaskEvent;
        toastService.createToast((
          <>
            Task
            {' '}
            <TaskLink id={event.data.id} name={event.data.name} />
            {' '}
            created
          </>
        ));
      },
      [TASK_UPDATED]: (eventData: EventData) => {
        const event = eventData as TaskEvent;
        toastService.createToast((
          <>
            Task
            {' '}
            <TaskLink id={event.data.id} name={event.data.name} />
            {' '}
            updated
          </>
        ));
      },
      [TASK_DELETED]: () => {
        toastService.createToast('Task deleted');
      },
      [TASK_COMPLETED]: (eventData: EventData) => {
        const event = eventData as TaskEvent;
        toastService.createToast((
          <>
            Task
            {' '}
            <TaskLink id={event.data.id} name={event.data.name} />
            {' '}
            completed
          </>
        ));
      },
      [TASK_UNCOMPLETED]: (eventData: EventData) => {
        const event = eventData as TaskEvent;
        toastService.createToast(<>
          Task
          {' '}
          <TaskLink id={event.data.id} name={event.data.name} />
          {' '}
          marked as incomplete
        </>);
      },
    },
    []
  );

  return null;
}
